import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { Form, Input, message } from 'antd';
import { AnimatePresence, motion } from 'framer-motion';
import React, { FC, useState } from 'react';
import { ContactUsParams, useContactUs } from '../../api/contactUs.api';
import { Button } from '../../components/@next/Button/Button';
import styles from './contactUsPage.module.scss';

const initialAnimationState = { height: 0, marginTop: 0, marginBottom: 0, opacity: 0 };

const QACollapsible: FC<{ question: string }> = ({ question, children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);

  return (
    <article className="contact-us__question flex-sb">
      <span className="question" onClick={isOpen ? close : open}>
        {question}
      </span>
      {isOpen ? <MinusOutlined onClick={close} /> : <PlusOutlined onClick={open} />}
      <AnimatePresence>
        {isOpen && (
          <motion.p
            initial={initialAnimationState}
            animate={{ height: 'auto', marginTop: '1rem', marginBottom: '1rem', opacity: 1 }}
            exit={initialAnimationState}
            className="answer"
          >
            {children}
          </motion.p>
        )}
      </AnimatePresence>
    </article>
  );
};

export const ContactUs: React.FC = () => {
  const [form] = Form.useForm<ContactUsParams>();
  const questions = {
    'What is Secure Trade Club?': (
      <div>
        Secure Trade Club (STC) is an innovative platform designed with the Serious Collector in
        mind. Our Founders are all collectors and have been involved in various Hobbies since they
        were kids and love the hunt! From picking at yard sales, to collecting Sports Cards from
        Baseball Card Shops the journey to STC has been an exciting ride. However, the purity of the
        Hobby has been lost in big business and making the simplicity of trading collectibles with
        those who share a similar passion a thing of the past. We want to bring that back. So on STC
        you can Trade, Buy and Sell your Collectibles with people who share the same interests and
        passions you do all in a Secure environment.
      </div>
    ),
    'How are you making it Secure?': (
      <div>
        First, STC is a Club. Like a membership based club we protect what we value most, and every
        member of STC will have a voice and be able to speak out when they see something not right,
        and they will be heard! Creating the Club environment has critical components needed, and
        one of those is ensuring every member who joins and is a paying member has been properly
        identified and confirmed as a Secure Member. You will see this prominently displayed as a
        Security Badge on a Members profile. If the Badge has an “X” in it, that means that is a
        free user just checking the Club out and may not be a Secure Member. It is why we encourage
        everyone to join the Club! The platform also is secure from the backend to the frontend with
        best practice security web methods to ensure every members data and information is kept
        private and secure. Finally we offer options for exchanging items that 1. Ensure payment of
        the items upon sell or trade, and 2. Allow for a Mediator or a Safe Meetup location for
        every transaction. Until the items are properly checked in no money is transferred, but upon
        deal completion the funds are released.
      </div>
    ),
    'How can I Trade on your site?': (
      <div>
        Trading with other Members is at the core of why we wanted to launch Secure Trade Club. The
        system has been uniquely built to allow for Members to search each others Showcases and find
        collectibles they want to trade for. Once they find the item or items they want to trade
        for, as a unique feature to STC is the ability to add as many items as you want to the deal,
        you can easily make a Cash offer for the items or Create a Trade. The system will prompt
        each user to select from their own Showcase the items they want to offer in Trade and then
        also allow for Money to be requested or added to the deal to make up the difference. It is a
        one of a kind method exclusive to STC for handling the lost art of trading all withing a
        managed environment for Collectors.
      </div>
    ),
    'How can I ensure I get my items?': (
      <div>
        STC has heard from so many Collectors the stories of bad buyers or sellers who are out to
        scam others. While I wish it would be possibly for us to say we can completely eliminate
        this from the Hobby, that would be impossible. But we do feel we have enough methods
        deployed to deter and lower the amount of deals going bad. First, we allow for Video to be
        posted at various points of the deal: 1. In the Listing of the Item, 2. Shipping of the
        Item, 3. Receipt of the Item so that it can go beyond just a photo showing something which
        can be easily altered to a video that shows the item completely, and being shipped and being
        received. We also allow for collectibles to be exchanged as a meetup in person at a Safe
        Trade Location that Law Enforcement all across the Country have approved as well as a
        Mediator Option for a middle person (Hobby shop or Collectible Dealer) to mediate the deal
        and alert you when the items have arrived.
      </div>
    ),
    'Can you explain more about the Mediator Option?': (
      <div>
        STC has a list of VIP Members who will contain our Mediators. Mediators are required to have
        a Brick and Mortar location so collectors can go to their physical shop and obtain their
        items once they arrive. There is a nominal fee for this to be added to the deal of $5. That
        money is paid directly to the Dealer so they can handle the check-in of the items and alert
        the Member to come and pick up the item. They can also alert the user if the items are a
        scam or the box was sent empty, and the deal is immediately halted and no items have been
        exchanged. We can then have the Collector step in and get their item(s) safely back and the
        money returned in the case of a scam. The mediator option is one more level of Security and
        protection needed with the Hobby. These Mediators will be growing and expanding over time,
        so if there is not one near you right now, don’t worry we have team members who are growing
        this list everyday!
      </div>
    ),
    'How does your fee structure work?': (
      <div>
        This has been one of the most challenging aspects to creating the platform. As the reality
        is to launch a Multi-million dollar platform such as STC there are costs and on-going costs,
        but we also want to move away from gauging the collectors with high fees. So with other
        auction and listing sites charging in excess of 10-25% Value fees + 3-5% Payment processing
        Fees, we wanted to give our Members a chance to “Buy Down” the Value Fees. So each
        Membership level will come with the 5% processing fee only.
      </div>
    ),
    'What perks are there going to be as a Member?': (
      <div>
        We are collectors as well and love the SWAG and perks from a Membership. For all paying Tier
        Memberships we are going to be doing quarterly Virtual or In-Person Meet-and- Greets with
        Celebrities, Hall of Fame Athletes and more. We also will be doing Case Breaks, Autograph
        Giveaways and more to celebrate our Members. So it will be a rewarding experience for being
        a Secure Member of STC!
      </div>
    ),
    'How can I suggest feedback?': (
      <div>
        We want to hear from you!! This platform is going to be expanding into other Collectible
        genres and we are going to be releasing new features, but we want to hear from our Members!
        Please Contact Us with ideas, likes, dislikes, would love to have features and let us work
        on them! We want this to be a growing site that offers cool new features such as Virtual
        Trade Shows, Live Events, Trade/Buy from your favorite stars and athletes and more! We have
        a list of ideas, but it always comes back to what you want to see, so please let us know by
        clicking on Contact Us today!
      </div>
    ),
  };
  const { TextArea } = Input;
  const contactUs = useContactUs({
    onSuccess: () => {
      message.success('Your message is sent!');
      form.resetFields();
    },
    onError: (err) => {
      message.error(err.message);
    },
  });

  return (
    <main className={styles['contact-us']}>
      <section className="contact-us__header"></section>
      <section className="contact-us__hero">
        <h2>Frequently Asked Questions</h2>
        <div className="general-questions">
          {Object.entries(questions).map((query, index) => (
            <QACollapsible key={index} question={query[0]}>
              {query[1]}
            </QACollapsible>
          ))}
        </div>
      </section>
      <section className="contact-us__form-container">
        <Form onFinish={contactUs.mutate} form={form} className="contact-us-form">
          <h2>
            Please describe in detail your issue, bug or recommendation for improvement below.{' '}
          </h2>
          <Form.Item label="Email or Username" name="email" className="email">
            <Input className="" />
          </Form.Item>
          <Form.Item label="PhoneNo" name="phoneNo" className="phone-no">
            <Input className="" />
          </Form.Item>
          <Form.Item label="Message" name="description" wrapperCol={{ span: 24 }}>
            <TextArea autoSize={{ minRows: 6, maxRows: 10 }} />
          </Form.Item>
          <Button htmlType="submit" loading={contactUs.isLoading}>
            Submit
          </Button>
        </Form>
      </section>
    </main>
  );
};
